import Button from '@mui/material/Button'
import { URL_APP } from 'helpers/config'
import images from 'assets/images'
import { useLocation } from 'react-router-dom'
import slack from 'helpers/integrations/slack'
import { Box } from '@mui/material'
import { RequesterType } from 'helpers/types'

type Props = {
  textButton: string
  id?: string
}

const AuthWithSlackButton = (props: Props) => {
  const location = useLocation()

  const onClick = () => {
    const searchParams = new URLSearchParams(location.search)
    slack.connect({
      action: 'LOGIN',
      next: searchParams.get('redirectUrl') || URL_APP,
      requester: searchParams.get('requester') as RequesterType,
    })
  }

  return (
    <Button
      onClick={onClick}
      id={props.id}
      color="primary"
      variant="outlined"
      sx={{
        width: '100%',
        textTransform: 'none',
        '&, &:hover': { borderColor: 'var(--blue)' },
      }}
    >
      <Box display="flex" justifyContent="center" alignItems="center" gap="8px">
        <img alt="imageSlack" src={images.SLACK_BUTTON_LOGO} width="20px" />
        <span className="link">{props.textButton}</span>
      </Box>
    </Button>
  )
}

export default AuthWithSlackButton
